import { getShiftsListWithTransformQueryOptions, type ForManagerLocationDetail } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: Pick<ForManagerLocationDetail, "id"> };

export const shiftsQuery = ({ location }: QueriesInput) =>
  getShiftsListWithTransformQueryOptions(
    { location_id: location.id },
    { query: { staleTime: Number.POSITIVE_INFINITY } },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [shiftsQuery(input)];
